import { Box, Checkbox, Modal } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import { useForm } from "react-hook-form";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import {
  getMonitorVitalsList,
  saveMonitorVital,
} from "../../../services/cliinicalChartServices/MonitorVitalsServices";
import CommonDynamicTablePaginationNew from "../../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import { format } from "date-fns";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

const MonitorVitalsModal = (props) => {
  const loggeduserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { openMonitorVitalsModal, setOpenMonitorVitalsModal, patientInfo } =
    props;

  const { control, watch } = useForm({
    defaultValues: {
      startDate: new Date(),
      startTime: null,
      endDate: new Date(),
      endTime: null,
    },
  });

  let getStartDate = watch("startDate");
  let getStartTime = watch("startTime");
  let getEndDate = watch("endDate");
  let getEndTime = watch("endTime");

  const [monitorVitalsList, setMonitorVitalsList] = useState([]);
  const [selectedVitalRow, setSelectedVitalRow] = useState(null);
  const [openPost, setOpenPost] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [listingObject, setListingObject] = useState({
    patientId: patientInfo?.MRNo,
    startDate: format(getStartDate, "yyyy-MM-dd"),
    startTime: getStartTime,
    endDate: format(getEndDate, "yyyy-MM-dd"),
    endTime: getEndTime,
    page: page,
    size: rowsPerPage,
    admissionId: Number(patientInfo?.AdmissionId),
  });

  const renderActions = (row, index) => {
    return (
      <fieldset>
        <Checkbox
          name={`check${index}`}
          size="small"
          disabled={row?.isverified}
          checked={row.check}
          onChange={(e) => {
            if (e.target.checked === true) {
              setSelectedVitalRow(row);
            }
            let temp = [...monitorVitalsList];
            for (let i = 0; i < temp.length; i++) {
              temp[i].check = i === index; // set true for the clicked one, false for others
            }
            setMonitorVitalsList(temp); // make sure to update state
          }}
        />
      </fieldset>
    );
  };

  const rowBackgroundColor = (row) => {
    if (row.isverified === true) {
      return "#F1F1F1";
    }
  };

  const populateMonitorVitalsList = (forPagination) => {
    getMonitorVitalsList(listingObject).then((response) => {
      let listData = response.data.result?.map((val) => ({
        ...val,
        check: false,
      }));
      if (listData?.length > 0) {
        if (forPagination) {
          setMonitorVitalsList((prevData) => [...prevData, ...listData]);
        } else {
          setMonitorVitalsList(listData);
        }
      }
    });
  };

  const addRecordMonitorVital = () => {
    saveMonitorVital({
      patientId: Number(patientInfo?.MRNo),
      bp: selectedVitalRow?.bp,
      pulseRate: selectedVitalRow?.pulserate,
      respiration: selectedVitalRow?.respiration,
      spo2: selectedVitalRow.spo2val,
      addedBy: loggeduserInfo?.empId,
    })
      .then((response) => {
        successAlert(response.data.message);
        setOpenPost(false);
        setSelectedVitalRow(null);
        populateMonitorVitalsList();
      })
      .catch((error) => {
        errorAlert(error.message);
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      populateMonitorVitalsList();
    }, 60000); // 60,000 ms = 1 minute

    // Optionally call it immediately on mount:
    // populateMonitorVitalsList();

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  useMemo(() => {
    populateMonitorVitalsList();
  }, [Object.values(listingObject)?.toString()]);

  console.log("monitorVitalsList321", monitorVitalsList);
  console.log("selectedVitalRow", selectedVitalRow);
  console.log("patientInfo963", patientInfo);

  return (
    <>
      <Modal open={openMonitorVitalsModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            minHeight: "50%",
            maxHeight: "95%",
            overflowY: "auto",
            bgcolor: "background.paper",
            border: "1px solid gray",
            boxShadow: 20,
            zIndex: 999,
            p: 2,
          }}
        >
          <div className="flex justify-between">
            <label className="font-semibold">Monitor Vitals</label>
            <button
              type="button"
              onClick={() => {
                setOpenMonitorVitalsModal(false);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          <div className="py-1">
            <hr className="border-t-[1px] border-[#E3E3E5]" />
          </div>
          <div className="grid grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 px-2 py-1 border bg-[#F7F9FB] rounded-md text-sm my-2 whitespace-nowrap">
            <div className="flex items-center space-x-2 col-span-2">
              <span className="font-semibold w-24">Patient Name</span>
              <span>:</span>
              <span className="text-customBlue font-bold text-base">
                {patientInfo?.["PatientName"]}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-20 lg:w-20 xl:w-10">MR No </span>
              <span className="text-gray-500">
                :&nbsp;
                {patientInfo?.MRNo}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-8 lg:w-8">Age </span>
              <span className="text-gray-500">
                :&nbsp;
                {patientInfo?.AgeYear}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-24 lg:w-24 xl:w-10">Gender</span>
              <span className="text-gray-500">
                :&nbsp;
                {patientInfo?.Gender}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-12 lg:w-12 xl:w-24 2xl:w-12">
                Bed No
              </span>
              <span className="text-gray-500">
                :&nbsp;
                {patientInfo?.BedNo}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-20">Last Added</span>
              <span className="text-gray-500">
                :&nbsp;
                {/* {patientInfo?.Gender} */}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-9 gap-x-2">
            <DatePickerField
              control={control}
              name="startDate"
              label="Start Date"
              inputFormat="dd-MM-yyyy"
            />
            <TimePickerFieldNew
              control={control}
              name="startTime"
              label="Start Time"
            />
            <DatePickerField
              control={control}
              name="endDate"
              label="End Date"
              inputFormat="dd-MM-yyyy"
            />
            <TimePickerFieldNew
              control={control}
              name="endTime"
              label="End Time"
            />
            <CommonButton
              type="button"
              searchIcon={true}
              className="bg-customBlue text-white"
              onClick={() => {
                setListingObject((listingObject) => ({
                  ...listingObject,
                  startDate: format(getStartDate, "yyyy-MM-dd"),
                  startTime: getStartTime,
                  endDate: format(getEndDate, "yyyy-MM-dd"),
                  endTime: getEndTime,
                  page: page,
                  size: rowsPerPage,
                }));
              }}
            />
          </div>
          {monitorVitalsList !== undefined && monitorVitalsList?.length > 0 ? (
            <>
              {/* <CommonDynamicTablePaginationNew
                dataResult={monitorVitalsList?.map((val) => ({
                  ...val,
                  "Reading Time": val.readingtime,
                  "BP Systolic": val.bpsys,
                  "BP Diastolic": val.bpdy,
                  "Pulse Rate": val.pulserate,
                  Spo2: val.spo2val,
                }))}
                renderActions={renderActions}
                highlightRow={false}
                removeHeaders={[
                  "check",
                  "id",
                  "bedno",
                  "patientname",
                  "pulserate",
                  "bpsys",
                  "spo2val",
                  "readingtime",
                  "bpdy",
                  "patientid",
                ]}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                populateTable={populateMonitorVitalsList}
              /> */}
              <CommonDynamicTableNew
                dataResult={monitorVitalsList?.map((val) => ({
                  ...val,
                  "Reading Time": val.readingtime,
                  BP: val.bp,
                  "BP MEAN": val.mean,
                  "Pulse Rate": val.pulserate,
                  Spo2: val.spo2val,
                  Respiration: val.respiration,
                  VPC: val.vpc,
                }))}
                renderActions={renderActions}
                highlightRow={false}
                rowBackgroundColor={rowBackgroundColor}
                removeHeaders={[
                  "check",
                  "id",
                  "bedno",
                  "patientname",
                  "pulserate",
                  "spo2val",
                  "readingtime",
                  "patientid",
                  "respiration",
                  "bp",
                  "vpc",
                  "mean",
                ]}
                tableClass="h-96"
              />
            </>
          ) : (
            <div className="flex items-center justify-center h-60 font-semibold border rounded my-2">
              No Records Found...
            </div>
          )}

          <div className="flex justify-end">
            <CommonButton
              type="button"
              label="Submit"
              className="bg-customGreen text-white"
              onClick={() => {
                if (monitorVitalsList?.some((val) => val.check === true)) {
                  setOpenPost(true);
                } else {
                  warningAlert("Please select vital...!");
                }
              }}
            />
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => setOpenPost(false)}
        confirmationSubmitFunc={addRecordMonitorVital}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to save this Vital ?"
        confirmationButtonMsg="Confirm"
      />
    </>
  );
};

export default MonitorVitalsModal;
